import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class PartnerContentStore {
  constructor() { }
  private _data = new BehaviorSubject([{}]);
  private _dataPartner = new BehaviorSubject([]);
  public get getAttrLoop() {
    return this._data.asObservable();
  }
  public setAttrLoop(data) {
    this._data.next(data);
  }
  public get partnerData() {
    return this._dataPartner.asObservable();
  }
  public setPartnerData(data) {
    this._dataPartner.next(data);
  }
}
